export default "__VITE_ASSET__Oc6xo77a__"